export default __webpack_public_path__ + "video24a356.png";